/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RequestMethod,
    RequestMethodFromJSON,
    RequestMethodFromJSONTyped,
    RequestMethodToJSON,
} from './RequestMethod';

/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {RequestMethod}
     * @memberof Link
     */
    method: RequestMethod;
    /**
     * Address of the link
     * @type {string}
     * @memberof Link
     */
    url: string;
}

export function LinkFromJSON(json: any): Link {
    return LinkFromJSONTyped(json, false);
}

export function LinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): Link {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': RequestMethodFromJSON(json['method']),
        'url': json['url'],
    };
}

export function LinkToJSON(value?: Link | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': RequestMethodToJSON(value.method),
        'url': value.url,
    };
}

